const rootClass = 'weet-components-switch';
export { rootClass };
